import React from 'react'
import { motion } from 'framer-motion'
import clsx from 'clsx'

export const Button = ({ 
  children, 
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  className,
  onClick,
  ...props 
}) => {
  const baseClasses = 'inline-flex items-center justify-center font-medium rounded-xl transition-all duration-300 focus:outline-none focus:ring-4'
  
  const variants = {
    primary: 'bg-brand-primary text-white hover:bg-primary-600 hover:shadow-lg focus:ring-primary-200',
    secondary: 'bg-brand-contentBg text-brand-darkText border-2 border-gray-300 hover:bg-gray-200 hover:shadow-sm focus:ring-gray-200',
    outline: 'bg-transparent border-2 border-brand-primary text-brand-primary hover:bg-primary-600 hover:text-white hover:shadow-sm focus:ring-primary-200',
    ghost: 'bg-transparent text-brand-darkText hover:bg-gray-200 hover:text-brand-darkText',
    success: 'bg-green-600 text-white hover:bg-green-700 hover:shadow-lg focus:ring-green-200',
    info: 'bg-blue-600 text-white hover:bg-blue-700 hover:shadow-lg focus:ring-blue-200',
    infoLight: 'bg-blue-500 text-white hover:bg-blue-600 hover:shadow-lg focus:ring-blue-200',
    neutral: 'bg-gray-600 text-white hover:bg-gray-700 hover:shadow-lg focus:ring-gray-200',
    danger: 'bg-red-600 text-white hover:bg-red-700 hover:shadow-lg focus:ring-red-200',
    report: 'bg-indigo-600 text-white hover:bg-indigo-700 hover:shadow-lg focus:ring-indigo-200'
  }
  
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  }
  
  const isDisabled = disabled || loading

  return (
    <motion.button
      className={clsx(
        baseClasses,
        variants[variant],
        sizes[size],
        isDisabled && 'opacity-50 cursor-not-allowed',
        className
      )}
      disabled={isDisabled}
      onClick={onClick}
      whileHover={!isDisabled ? { scale: 1.02, y: -2 } : {}}
      whileTap={!isDisabled ? { scale: 0.98, y: 0 } : {}}
      transition={{ duration: 0.2 }}
      {...props}
    >
      {loading && (
        <svg className="animate-spin -ml-1 mr-3 h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      )}
      {children}
    </motion.button>
  )
}
